<template>
  <div class="container mt-5 mb-5">
    <div class="d-flex justify-content-center row">
      <div class="col-md-10" style="max-width: 350px;">
        <div class="row p-2 bg-white border rounded">
          <img
            style="width: 100%; max-height: 240px;"
            :src="initialData.fragments.imgSrc"
            :alt="initialData.fragments.title"
            class="img-fluid img-responsive rounded product-image">
          <h5 style="text-align: center; width: 100%;">{{ initialData.fragments.title }}</h5>
          <div class="d-flex flex-column" style="margin-top: -70px; width: 100%;">
            <button class="btn btn-success" style="background-color: rgb(30, 126, 52, 0.5);"
              @click="$emit('comm-product-details', key)">Details</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
// import config from '@/config'
import { json2Html } from '@/service/utils/ProsemirrorConverter'
// import * as htmlUtil from '@/service/utils/html'
import * as events from '@/events'

const ADD_BTN_CLASS = 'btn btn-success',
  ADD_BTN_CLASS_DISABLED = 'btn-disabled',
  ADD_BTN_CONFETTI_CLASS = 'btn-confetti'

export default {
  name: 'comm-prod-listed-small',
  version: '0.0.1',
  props: {
    initialData: {
      type: Object,
      required: true,
      default: () => {}
    }, // initialData
    listIndex: {
      type: Number,
      required: true,
      default: 0
    }, // listIndex
    addBtnConfetti: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const _btnClassBase = this.addBtnConfetti ? ADD_BTN_CONFETTI_CLASS : ADD_BTN_CLASS
    return {
      /* Set to true if the content is loaded successfully, otherwise info is shown. */
      loaded: false,
      info: '... loading content!',
      addBtnClassBase: _btnClassBase,
      addBtnClass: _btnClassBase,
      addBtnClassDisabled: ADD_BTN_CLASS_DISABLED,
      key: '',
      formData: {}
    }
  }, // data
  async mounted () {}, // mounted
  methods: {
    json2Html,
    handleAdd2Basket () {
      console.log('TRACE-REMOVE: CommProduct.handleAdd2Basket: called!')
      const _payload = { commProduct: this.contentKey, amount: 1 }
      events.bus.emitGlobal(events.types.orders.GLGE_ADD_2_BASKET, _payload)
      this.addBtnClass = this.addBtnClassBase + ' animate'
      setTimeout(() => {
        this.addBtnClass = this.addBtnClassBase
      }, 700)
    } // handleAdd2Basket
  }
}
</script>

<style scoped>
@import '~bootstrap/dist/css/bootstrap.css';
/** TODO: check if necessary to reference all the *css files */
/* @import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~bootstrap-vue/dist/bootstrap-vue-icons.css'; */
@import '~@/assets/css/buttons.css';
</style>
